import styled from "styled-components";
import { InputContainer } from "../../../components/styled/Input";

export const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 0.5px solid #aeb1b8;
  border-radius: 12px;
  padding: 40px 0;
  margin: 60px 20px;
  width: 700px;

  @media (min-width: 758px) {
    width: 1024px;
  }

  h2 {
    font-size: 2rem;
    font-weight: 500;
  }

  ${InputContainer} {
    margin-bottom: 50px;
  }
`;

export const GuestCountContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;  
